import React, { Component } from 'react';
import styled, { createGlobalStyle, keyframes } from 'styled-components';
import { connect } from 'react-redux';
import LoadingComponent from '../../components/common/LoadingComponent';
import NewBenefitsCard from '../../components/policy/newBenefitsCard';
import { BoldText, Text, SemiBoldText } from '../../components/common/Text';
import NewClaimsCard from '../../components/policy/NewClaimsCard';
import NewHelpCard from '../../components/policy/NewHelpCard';
import {
  InsureTabApi,
  InsureTabOpdBenefits,
  consultationTab,
  getConsultationSummary,
  getSvg,
} from '../../services';
import { Carousel } from 'react-responsive-carousel';
import arrowLeft from '../../images/common/arrow-left.svg';
import Tappable from 'react-tappable/lib/Tappable';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import EyeIcon from '../../images/newInsurerPage/eyeIcon.svg';
import WalletCardBackground1 from '../../images/newInsurerPage/walletBackground1.svg';
import WalletCardBackground2 from '../../images/newInsurerPage/walletBackground2.svg';
import WalletCardBackground3 from '../../images/newInsurerPage/walletBackground3.svg';

import PurpleDownArrow from '../../images/policy/purpleArrowDown.svg';
import BlueDownArrow from '../../images/policy/blueArrowDown.svg';
import GreenDownArrow from '../../images/policy/greenArrowDown.svg';
import NewHealthBenefitsCard from '../../components/policy/NewHealthBenefitsCard';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  height: 100vh;
  background: #ffffff;
  overflow: hidden;

  @media (min-width: 768px) {
    height: 90vh;
  }
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  background: white;
  height: 90vh;
`;

const Body = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: stretch;
  padding-bottom: 2rem;
  overflow-x: hidden;
`;

const HeaderContainer = styled.div`
  // z-index: 9999;
  // position: fixed;
  // top: 0px;
  // left: 0px;
  // width: 100%;
  // display: flex;
  // flex-direction: column;
  // padding: 22px 0 18px;
  // align-self: stretch;
  // align-items: center;
  // justify-content: center;
  // border-bottom: 1px solid #f0f3f6;
  // background-color: white;

  display: flex;
  flex-direction: column;
  padding: 30px 0 18px;
  align-self: stretch;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f0f3f6;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

const HeaderText = styled(BoldText)`
  font-size: 16px;
  text-align: center;
  font-family: Inter;
  font-weight: 600;
`;
const SectionHeading = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  margin-bottom: 1rem;
`;
const Session = styled.div`
  width: 90%;
  margin: auto;
  //margin-top: 1rem;
  //margin-bottom: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e6e9ec;
`;
const BackContainer = styled(Tappable)`
  //   margin-right: 0.5rem;

  display: flex;
  width: 44px;
  align-items: center;
  justify-content: center;
  &.Tappable-active {
    opacity: 0.2;
  }
`;

const HeaderTitleContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

const styledElement = document.getElementsByClassName('carousel-root');

class OpdBenefits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      insured: false,
      opdPolicies: [],
      ipdPolicies: [],
      claims: [],
      opdWalletDetails: [],
      policyDetails: {},
      policySavings: {},
      reimbursementRequests: null,
      coiUrl: null,
      activeTabIndex: 0,
      activeTab: '',
      opdDependentWallet: [],
      dependentSelectedWallet: {},
      opdEcards: [],
      benefitsSection: [],
      claimsSection: [],
      helpSection: [],
      offersSection: [],
      walletSection: [],
      currentOpenCard: null,
      healthBenefits: [],
      cards: [],
      policyDocumentLink: null,
      services: [],
      blockers: {},
    };
  }

  Header() {
    return (
      <HeaderContainer>
        <Header>
          <BackContainer onTap={() => this.props.history.goBack()}>
            <img src={arrowLeft} alt="back" />{' '}
          </BackContainer>
          <HeaderText>Opd Benefits Details</HeaderText>
        </Header>
      </HeaderContainer>
    );
  }
  //   {
  //     <HeaderContainer>
  //             <BackContainer onTap={() => history.push('/home')}>
  //               <img src={arrowLeft} alt="back" />
  //             </BackContainer>
  //             <HeaderTitleContainer>
  //               <HeaderText>Clinic Consultation </HeaderText>
  //             </HeaderTitleContainer>
  //           </HeaderContainer>
  //   }
  requestReimbursement = (ele) => {
    const { history } = this.props;
    if (ele.fulfillmentDetailsAvailable) {
      history.push('/reimbursement');
    } else {
      history.push('/reimbursement/fulfillment-details', {
        fulfillmentDetailsAvailable: ele.fulfillmentDetailsAvailable,
        from: 'normal-flow',
        details: ele,
      });
    }
  };
  findSpecialist = (pendingConsult, cancelledRequest) => {
    const { history, authToken, userId } = this.props;
    if (cancelledRequest > 0) {
      history.push('/consultation/cancel-blocker', {
        requestId: cancelledRequest,
      });
    } else if (pendingConsult > 0) {
      getConsultationSummary(pendingConsult, userId, authToken)
        .then((summary) => {
          const { dateLabel, doctorId, doctorName, doctorImg } =
            summary.consultationInfo;
          this.setState({
            pendingConsult: {
              consultationId: pendingConsult,
              doctorId,
              doctorImg,
              doctorName,
              dateLabel,
            },
            showModal: true,
            showPendingConsultBlocker: true,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      history.push('/consultation/preview', {
        specialistSearch: false,
        searchType: 'find',
      });
    }
  };
  startTreament = (showSearch, pendingConsult, cancelledRequest) => {
    const { history, authToken, userId } = this.props;
    if (cancelledRequest > 0) {
      history.push('/consultation/cancel-blocker', {
        requestId: cancelledRequest,
      });
    } else if (pendingConsult > 0) {
      getConsultationSummary(pendingConsult, userId, authToken)
        .then((summary) => {
          const { dateLabel, doctorId, doctorName, doctorImg } =
            summary.consultationInfo;
          this.setState({
            pendingConsult: {
              consultationId: pendingConsult,
              doctorId,
              doctorImg,
              doctorName,
              dateLabel,
            },
            showModal: true,
            showPendingConsultBlocker: true,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      history.push('/consultation/online/preview', {
        specialistSearch: false,
        searchType: 'find',
        showSearch,
      });
    }
  };
  renderService(ele, stng) {
    //console.log('elem and stng are ', ele, stng);
    const { cardType } = ele;
    if (cardType === stng) {
      switch (cardType) {
        // case 'hospitalisation':
        //   return (
        //     <StyledActionCard
        //       key={cardType}
        //       onTap={() => {
        //         logEvent('hospitalisation-request');
        //         this.showHospitalization(ele);
        //       }}
        //       title={ele.label}
        //       subtitle={ele.description}
        //       offer={ele.offer}
        //     />
        //   );
        case 'online-consults':
          this.startTreament(
            ele.allowSearch,
            ele.pendingConsult,
            ele.cancelledRequest
          );
          break;

        case 'offline-consults':
          this.findSpecialist(ele.pendingConsult, ele.cancelledRequest);
          break;
        // case 'diagnostics':
        //   return (
        //     <StyledActionCard
        //       key={cardType}
        //       onTap={this.bookTests}
        //       title={ele.label}
        //       icon={labIcon}
        //       subtitle={ele.description}
        //       discountText={ele.labelBanner}
        //       offer={ele.offer}
        //     />
        //   );
        // case 'sym-check':
        //   return (
        //     <StyledActionCard
        //       key={cardType}
        //       onTap={() => this.runAction(ele)}
        //       title={ele.label}
        //       subtitle={ele.description}
        //       offer={ele.offer}
        //       icon={symptonIcon}
        //     />
        //   );
        // case 'hra-card':
        //   return (
        //     <StyledActionCard
        //       key={cardType}
        //       onTap={() => this.runAction(ele)}
        //       title="Health Risk Assessment"
        //       subtitle="Get insights into your health"
        //       icon={hraIcon}
        //     />
        //   );
        case 'reimbursement':
          this.requestReimbursement(ele);
          break;
        // case 'support':
        //   return (
        //     <div
        //       className="support-card mb-5 hover"
        //       onClick={this.openSupport}
        //       key={cardType}
        //     >
        //       <div className="flex-center">
        //         <img src={ChatIcon} alt="chat" />
        //         <p className="ml-5">{ele.label}</p>
        //       </div>
        //       <ArrowIcon />
        //     </div>
        //   );
        // case 'claims':
        //   return (
        //     <StyledActionCard
        //       key={cardType}
        //       onTap={() => this.myClaims(ele)}
        //       title={ele.label}
        //       subtitle={ele.description}
        //       offer={ele.offer}
        //       icon={claimIcon}
        //     />
        //   );
        // case 'html':
        //   const link = ele.link;
        //   const url = new URL(
        //     decodeURIComponent(ele.cardDirective.action.redirectTo)
        //   );
        //   return (
        //     <div
        //       className="cursor-pointer"
        //       onClick={() => {
        //         if (url) {
        //           window.open(url, '_blank');
        //         }
        //       }}
        //     >
        //       <img src={link.split('=')[1]} alt="ahc" />
        //     </div>
        //   );
        // case 'pharmacy':
        //   if (ele.showPharmacy) {
        //     return (
        //       <StyledActionCard
        //         key={cardType}
        //         onTap={() => this.medicineOrder(ele)}
        //         title={ele.label}
        //         subtitle={ele.description}
        //         offer={ele.offer}
        //         icon={medIcon}
        //       />
        //     );
        //   }
        //   return;

        // case 'con-assistant':
        //   return (
        //     <div
        //       className="blue-box flex-row-center-end"
        //       key={cardType}
        //       style={{
        //         paddingRight: '14px',
        //       }}
        //       onClick={() => {
        //         if (this.state.blockers.cancelledRequest > 0) {
        //           this.props.history.push('/consultation/cancel-blocker', {
        //             requestId: this.state.blockers.cancelledRequest,
        //           });
        //         } else {
        //           this.props.history.push('/consultation/doctor-select', {
        //             specialistSearch: false,
        //             showVerticals: ele.showVerticals,
        //             searchType: 'treat',
        //           });
        //         }
        //       }}
        //     >
        //       <div>
        //         <span className="txt-white-600-13">{ele.label}</span>
        //         <br />
        //         <span className="txt-500-white-12">{ele.description}</span>
        //       </div>
        //       <div className="h-100">
        //         <span className="vertical-line" />
        //         <FaChevronRight
        //           style={{
        //             color: '#ffffff',
        //             fontSize: '14px',
        //             width: '8px',
        //           }}
        //         />
        //       </div>
        //     </div>
        //   );
        default:
          return false;
      }
    }
  }
  getItDone(stng) {
    if (this.state.services.length > 0) {
      this.state.services.map((item) => this.renderService(item, stng));
    }
  }
  getAppropriateRoute(key, serv = null) {
    // console.log('look', key);
    switch (key) {
      case 'labs':
        return this.props.history.push('/lab-test');
      case 'pharmacy':
        return this.props.history.push('/pharmacy');
      case 'reimbursement':
        this.getItDone('reimbursement');
        break;
      case 'offline-consult':
        this.getItDone('offline-consults');
        break;
      case 'online-consult':
        this.getItDone('online-consults');
        break;
      case 'help':
        return this.props.history.push('/home/insure/faq?hidetabs=true');
      default:
        return '';
    }
  }
  getConsults() {
    const { authToken, history } = this.props;
    consultationTab(authToken)
      .then((res) => {
        const services = res.console;
        this.setState({
          services,
          blockers: res.blockers,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getBackground(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return WalletCardBackground1;
      case 1:
        return WalletCardBackground2;
      case 2:
        return WalletCardBackground3;
      default:
        return '';
    }
  }
  getBackgroundColor(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;

    switch (backgroundIndex) {
      case 0:
        return 'linear-gradient(132deg, rgba(249, 126, 124, 0.20) 0%, rgba(255, 109, 162, 0.10) 95.83%)';
      case 1:
        return 'linear-gradient(136deg, #C7EBFF 0%, rgba(211, 237, 255, 0.56) 91.69%)';
      case 2:
        return 'linear-gradient(151deg, rgba(146, 220, 70, 0.20) 0.01%, rgba(232, 228, 110, 0.20) 100%)';
      default:
        return '';
    }
  }
  getArrow(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return PurpleDownArrow;
      case 1:
        return BlueDownArrow;
      case 2:
        return GreenDownArrow;
      default:
        return '';
    }
  }
  getIcon(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return 'brightness(0) saturate(100%) invert(81%) sepia(63%) saturate(5061%) hue-rotate(314deg) brightness(86%) contrast(105%)';
      case 1:
        return 'brightness(0) saturate(100%) invert(42%) sepia(83%) saturate(620%) hue-rotate(161deg) brightness(92%) contrast(74%)';
      case 2:
        return 'brightness(0) saturate(100%) invert(68%) sepia(12%) saturate(2351%) hue-rotate(35deg) brightness(94%) contrast(89%)';
      default:
        return '';
    }
  }
  // getModifiedSvg(svg, authToken) {
  //   //const svgUrl = svg;
  //   getSvg(svg, authToken).then((res) =>
  //     console.log('response is ', res).catch((err) => console.log(err))
  //   );
  //   // let finalSvg = fetch(svgUrl)
  //   //   .then((response) => {
  //   //     //response.text();
  //   //     console.log('resp is ', response.text());
  //   //   })
  //   //   // .then((svgContent) => {
  //   //   //   // Continue to the next step
  //   //   //   console.log('svg content is ', svgContent);
  //   //   //   //return svgContent;
  //   //   // })
  //   //   .catch((error) => {
  //   //     console.error('Error fetching SVG:', error);
  //   //   });
  //   // //console.log('svg file response', finalSvg);
  // }
  getTextColor(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return '#E16262';
      case 1:
        return '#2E89BD';
      case 2:
        return '#90B529';
      default:
        return '';
    }
  }
  onCardTap(index) {
    if (this.state.currentOpenCard === index) {
      this.setState({ currentOpenCard: null });
    } else {
      this.setState({ currentOpenCard: index });
    }
  }

  renderBody() {
    return (
      <div>
        {this.state &&
        this.state.opdEcards &&
        this.state.opdEcards.length > 1 ? (
          <CarouselOuterContainer>
            <Carousel
              showIndicators={true}
              showStatus={false}
              centerMode={true}
              showThumbs={false}
              swipeable
              centerSlidePercentage="90"
            >
              {this.state.opdEcards &&
                this.state.opdEcards.map((eCard) => {
                  return (
                    <CardDiv key={eCard.age}>
                      <CardHeader>
                        <CardInsurerLogoContainer>
                          <img src={eCard.insurerLogo} />
                        </CardInsurerLogoContainer>
                        <CardTitle>OPD E-Card</CardTitle>
                      </CardHeader>
                      <CardData>
                        <CardPtag>Member Name</CardPtag>

                        <CardPtag2>{eCard.memberName}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Age</CardPtag>

                        <CardPtag2>{eCard.age}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Policy Number</CardPtag>

                        <CardPtag2>{eCard.policyNumber}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Valid Till</CardPtag>

                        <CardPtag2>{eCard.validTill}</CardPtag2>
                      </CardData>
                      <CardFooter>
                        <CardSponsorLogoContainer>
                          <CardPtag>Corporate Name</CardPtag>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'left',
                            }}
                          >
                            <img
                              src={eCard.sponsorLogo}
                              style={{ width: '55%' }}
                            />
                          </div>
                        </CardSponsorLogoContainer>
                      </CardFooter>
                    </CardDiv>
                  );
                })}
            </Carousel>
          </CarouselOuterContainer>
        ) : (
          <CarouselOuterContainer>
            <Carousel
              showIndicators={false}
              showStatus={false}
              centerMode={true}
              showThumbs={false}
              swipeable
              centerSlidePercentage="100"
            >
              {this.state.opdEcards &&
                this.state.opdEcards.map((eCard) => {
                  return (
                    <CardDiv key={eCard.age}>
                      <CardHeader>
                        <CardInsurerLogoContainer>
                          <img src={eCard.insurerLogo} />
                        </CardInsurerLogoContainer>
                        <CardTitle>OPD E-Card</CardTitle>
                      </CardHeader>
                      <CardData>
                        <CardPtag>Member Name</CardPtag>

                        <CardPtag2>{eCard.memberName}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Age</CardPtag>

                        <CardPtag2>{eCard.age}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Policy Number</CardPtag>

                        <CardPtag2>{eCard.policyNumber}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Valid Till</CardPtag>

                        <CardPtag2>{eCard.validTill}</CardPtag2>
                      </CardData>
                      <CardFooter>
                        <CardSponsorLogoContainer>
                          <CardPtag>Corporate Name</CardPtag>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'left',
                            }}
                          >
                            <img
                              src={eCard.sponsorLogo}
                              style={{ width: '55%' }}
                            />
                          </div>
                        </CardSponsorLogoContainer>
                      </CardFooter>
                    </CardDiv>
                  );
                })}
            </Carousel>
          </CarouselOuterContainer>
        )}
        {this.state && this.state.policyDocumentLink && (
          <BenefitsDocumentCard
            onTap={() => window.open(this.state.policyDocumentLink, '_blank')}
          >
            <BenefitsDocLinkContainer>
              <img src={EyeIcon} />
              <CardPtag3>View Benefits Document</CardPtag3>
            </BenefitsDocLinkContainer>
          </BenefitsDocumentCard>
        )}
        {this.state &&
          this.state.walletSection &&
          this.state.walletSection.length > 0 && (
            <Session>
              <SectionHeading>Your Wallet Balance</SectionHeading>
              <WalletDetailsContainer>
                {this.state.walletSection.map((item, index) => {
                  if (index > 0) {
                    return (
                      <TappableCard onTap={() => this.onCardTap(index)}>
                        <WalletDetailsMain
                          //   style={{
                          //     background: WalletCardBackground3,
                          //     //background: this.getBackgroundColor(index),
                          //   }}
                          bgSvg={this.getBackground(index)}
                          bgColor={this.getBackgroundColor(index)}
                          //bg={WalletCardBackground1}
                          //onClick={() => this.onCardTap(index)}
                        >
                          <WalletDetailsInner>
                            <DetailsLeft
                              style={{ color: this.getTextColor(index) }}
                            >
                              {item.newLabel}
                            </DetailsLeft>
                            <DetailsRight
                              style={{ color: this.getTextColor(index) }}
                            >
                              {item.isUnlimitedTitle ? (
                                <Numerator
                                  style={{ color: this.getTextColor(index) }}
                                >
                                  Unlimited
                                </Numerator>
                              ) : (
                                <>
                                  <Numerator
                                    style={{ color: this.getTextColor(index) }}
                                  >
                                    ₹ {item.availableBalanceText} /
                                  </Numerator>
                                  <Denominator
                                    style={{ color: this.getTextColor(index) }}
                                  >
                                    ₹ {item.totalBalanceText}
                                  </Denominator>
                                </>
                              )}
                            </DetailsRight>
                          </WalletDetailsInner>
                          <ArrowContainer>
                            <img src={this.getArrow(index)} />
                          </ArrowContainer>
                        </WalletDetailsMain>
                        {index === this.state.currentOpenCard && (
                          <SlidingDiv bgColor={this.getBackgroundColor(index)}>
                            <SlidingDivCol1>
                              <Numerator
                                style={{ color: this.getTextColor(index) }}
                              >
                                Benefits
                              </Numerator>
                            </SlidingDivCol1>
                            {item.servicesCovered.length > 0 &&
                              item.servicesCovered.map((serviceItem) => {
                                return (
                                  <SlidingDivCol2>
                                    <SlidingInnerDiv
                                      style={{
                                        color: this.getTextColor(index),
                                      }}
                                    >
                                      {/* <div style={{ width: '20px' }}>
                                        {this.getModifiedSvg(
                                          serviceItem.svgIcon,
                                          this.props.authToken
                                        )}
                                      </div> */}
                                      <img
                                        src={serviceItem.icon}
                                        style={{
                                          width: '20px',
                                          filter: this.getIcon(index),
                                        }}
                                      />
                                      {/* {serviceItem.svgIcon} */}
                                      {serviceItem.label}
                                    </SlidingInnerDiv>
                                    <SlidingInnerDiv
                                      style={{
                                        color: this.getTextColor(index),
                                      }}
                                    >
                                      ₹ {serviceItem.amountSpent}
                                    </SlidingInnerDiv>
                                  </SlidingDivCol2>
                                );
                              })}
                            <SlidingDivCol3
                              style={{ color: this.getTextColor(index) }}
                            >
                              Total Spends{' '}
                              <Numerator>
                                {' '}
                                ₹ {item.servicesCovered && item.totalSpent}
                              </Numerator>
                            </SlidingDivCol3>
                          </SlidingDiv>
                        )}
                      </TappableCard>
                    );
                  } else {
                    return null;
                  }
                })}
                {/* {console.log('wallet section is ', this.state.walletSection[0])} */}
                <WalletDetailsDoop>
                  <WalletDetailsInner>
                    <DetailsLeftDoop>Available Balance</DetailsLeftDoop>
                    <DetailsRightDoop>
                      {this.state.walletSection[0].isUnlimitedTitle ? (
                        <>{this.state.walletSection[0].isUnlimitedText}</>
                      ) : (
                        <>
                          <NumeratorDoop>
                            ₹ {this.state.walletSection[0].availableBalanceText}
                            /
                          </NumeratorDoop>
                          <DenominatorDoop>
                            ₹ {this.state.walletSection[0].totalBalanceText}
                          </DenominatorDoop>
                        </>
                      )}
                    </DetailsRightDoop>
                  </WalletDetailsInner>
                  <ArrowContainerDoop>
                    {this.state.walletSection[0].description}
                  </ArrowContainerDoop>
                </WalletDetailsDoop>
              </WalletDetailsContainer>
            </Session>
          )}
        {/* {this.state &&
          this.state.services &&
          this.state.services.map((item) =>
            console.log('services item is ', item)
          )} */}
        {this.state &&
          this.state.healthBenefits &&
          this.state.healthBenefits.length > 0 && (
            <Session>
              <SectionHeading>Health Benefits</SectionHeading>

              {this.state.healthBenefits.map((item) => (
                <NewHealthBenefitsCard
                  data={item}
                  onTap={() =>
                    this.getAppropriateRoute(item.themeKey, this.state.services)
                  }
                />
              ))}
            </Session>
          )}
        {this.state && this.state.cards && this.state.cards.length > 0 && (
          <Session>
            <SectionHeading>Claims</SectionHeading>
            {this.state.cards &&
              this.state.cards.map((item) => {
                if (item.key === 'claims')
                  return item.cards.map((innerItem) => (
                    <NewClaimsCard
                      data={innerItem}
                      onTap={() => this.props.history.push('/claims')}
                    />
                  ));
              })}
          </Session>
        )}
        {this.state && this.state.cards && this.state.cards.length > 0 && (
          <Session>
            <SectionHeading>Help</SectionHeading>
            {this.state.cards &&
              this.state.cards.map((item) => {
                if (item.key === 'help') {
                  return item.cards.map((innerItem) => (
                    <NewHelpCard
                      data={innerItem}
                      onTap={() => this.getAppropriateRoute(innerItem.themeKey)}
                    />
                  ));
                }
              })}
          </Session>
        )}
        {/* <div
          style={{
            height: '100px',
            width: '250px',
            // background:
            //   'linear-gradient(132deg, rgba(249, 126, 124, 0.20) 0%, rgba(255, 109, 162, 0.10) 95.83%)',
            background: WalletCardBackground1,
          }}
        >
          <h1>hello world</h1>
        </div> */}

        {/* {this.state.claimsSection.length > 0 && (
          <Session>
            <SectionHeading>Claims</SectionHeading>
            {this.state.claimsSection.map((item) => (
              <NewClaimsCard data={item} />
            ))}
          </Session>
        )}
        {this.state.helpSection.length > 0 && (
          <Session>
            <SectionHeading>Help</SectionHeading>
            {this.state.helpSection.map((item) => (
              <NewHelpCard data={item} />
            ))}
          </Session>
        )} */}
      </div>
    );
  }
  fetchData() {
    const { authToken } = this.props;
    // console.log('this props are', this.props);
    const { state } = this.props.location;
    // console.log('policyId is ', state);
    if (state && state.policyId) {
      InsureTabOpdBenefits(authToken, state.policyId)
        .then((response) => {
          const opdData = response;
          this.setState({ opdEcards: opdData.opdPolicies.eCards });
          // this.setState({
          //   opdEcards: [
          //     {
          //       insurerLogo:
          //         'https://api.getvisitapp.com/apiv3/sponsor-images/sponsor-77.png',
          //       memberName: 'Chinmay Kumar Dash',
          //       age: 24,
          //       policyNumber: 'VISIT082022OPD',
          //       policyNumberTitle: 'Policy Number',
          //       validTill: '30th August 2023',
          //       sponsorLogo:
          //         'https://api.getvisitapp.com/apiv3/sponsor-images/sponsor-77.png',
          //       coiUrl: null,
          //       showPolicyNumber: 1,
          //     },
          //     {
          //       insurerLogo:
          //         'https://api.getvisitapp.com/apiv3/sponsor-images/sponsor-77.png',
          //       memberName: 'Chinmay Kumar Dash',
          //       age: 32,
          //       policyNumber: 'VISIT082022OPD',
          //       policyNumberTitle: 'Policy Number',
          //       validTill: '30th August 2023',
          //       sponsorLogo:
          //         'https://api.getvisitapp.com/apiv3/sponsor-images/sponsor-77.png',
          //       coiUrl: null,
          //       showPolicyNumber: 1,
          //     },
          //   ],
          // });
          this.setState({
            walletSection: opdData.opdUniqueWallets[0].walletDetails,
          });
          this.setState({
            healthBenefits: opdData.opdPolicies.healthBenefits,
          });
          this.setState({ cards: opdData.cards });
          this.setState({ policyDocumentLink: opdData.policyDocumentLink });
        })
        .catch((err) => console.log('err is', err))
        .finally(() => this.setState({ loading: false }));
    }
  }

  componentDidMount() {
    if (this.props.loginState !== 'LOGGED_IN' || !this.props.authToken) {
      this.props.history.push('/');
    } else {
      this.getConsults();
      this.fetchData();
    }

    //const opdData = this.OpdCardData();

    //console.log('ocards is ', opdData.cards);
    //console.log('wallet data ', opdData.opdUniqueWallets[0].walletDetails);
    //this.setState({ loading: false });
    //console.log('healthbenefits are ', opdData.opdPolicies.healthBenefits);

    // this.getModifiedSvg(
    //   'https://visit-public.s3.ap-south-1.amazonaws.com/assets/new-icons/Tablets.svg',
    //   this.props.authToken
    // );
  }
  render() {
    return !this.state.loading ? (
      <OuterContainer>
        {this.Header()}
        <BodyContainer>
          <Body>{this.renderBody()}</Body>
        </BodyContainer>
      </OuterContainer>
    ) : (
      <LoadingComponent />
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  loginState: state.app.loginState,
  profileImage: state.user.profileImage,
  sponsorId: state.user.sponsorId,
  showSubscription: state.app.config.showSubscription,
  showOPD: state.app.config.showOPD,
  insured: state.app.config.insured,
  userId: state.user.userId,
  subscribed: state.app.config.subscribed,
});

export default connect(mapStateToProps)(OpdBenefits);

const CardDiv = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid #d9d9d9;
  border-radius: 20px;
  margin-right: 1rem;
  margin-left: 1rem;
`;
const CardHeader = styled.div`
  display: flex;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  justify-content: space-between;
  align-items: center;
  background: #f5f4ff;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
`;
const CardData = styled.div`
  display: flex;
  justify-content: space-between;
  width:85%
  margin:auto;
  padding-top: 1rem;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid #E6E9EC;
  
`;
const CardInsurerLogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 55px;
  height: 55px;
`;
const CardSponsorLogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  gap: 5px;
  width: 80px;
  //height: 45px;
`;
const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  align-items: center;
  background: #fff;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
`;
const CardTitle = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 140%;
`;
const CardPtag = styled.p`
  display: flex;
  align-items: center;
  color: #666;
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: normal;
`;
const CardPtag2 = styled.p`
  display: flex;
  align-items: center;
  color: #373737;
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 150%;
`;
const CardPtag3 = styled.p`
  display: flex;
  align-items: center;
  color: #373737;
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 150%;
  padding: 0.5rem;
`;
const CarouselOuterContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;
const BenefitsDocumentCard = styled(Tappable)`
  &.Tappable-active {
    opacity: 0.2;
  }
`;
const BenefitsDocLinkContainer = styled.div`
  display: flex;
  width: 90%;
  margin: auto;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  border: 1px solid var(--text-box-card, #e6e9ec);
  background: var(--white, #fff);
`;
const WalletDetailsContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #ebe5ff;
  background: #fff;
`;
const TappableCard = styled(Tappable)`
  &.Tappable-active {
    opacity: 0.2;
  }
`;
const WalletDetailsMain = styled.div`
  padding: 0.5rem;
  display: flex;
  background: ${(props) => `url(${props.bgSvg})`},
    ${(props) => `${props.bgColor}`};
  flex-direction: column;
  border-radius: 10px;
  row-gap: 10px;
  margin: 0.8rem;
`;
const WalletDetailsDoop = styled.div`
  display: flex;
  background: ${(props) => `${props.bgColor}`};
  flex-direction: column;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  row-gap: 5px;
  width: 90%;
  margin: auto;
  padding-top: 0.8rem;
  border-top: 1px solid #e6e6e6;
`;
const ArrowContainerDoop = styled.div`
  display: flex;
  align-self: flex-start;
  color: #ffbb00;
  font-family: Inter;
  font-size: 9px;
  font-weight: 500;
  padding-bottom: 0.5rem;
`;
const WalletDetailsInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const DetailsLeft = styled.p`
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  width: 60%;
`;
const DetailsRight = styled.p`
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
`;
const ArrowContainer = styled.div`
  display: flex;
  align-self: flex-end;
`;
const DetailsLeftDoop = styled.p`
  color: #ffbb00;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
`;
const DetailsRightDoop = styled.p`
  color: #ffbb00;
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-weight: 800;
`;
const Numerator = styled.span`
  padding-left: 5px;
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-weight: 800;
`;
const Denominator = styled.span`
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
`;

const NumeratorDoop = styled.span`
  color: #ffbb00;
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-weight: 800;
`;
const DenominatorDoop = styled.span`
  color: #ffbb00;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
`;
const slideIn = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;
const SlidingDiv = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => `${props.bgColor}`};
  padding: 0.5rem;
  border-radius: 10px;
  row-gap: 10px;
  margin: 0.8rem;
  animation: ${slideIn} 2s ease-out;
`;

const SlidingDivCol1 = styled.div`
  display: flex;
  align-self: flex-start;
  font-family: Inter;
`;
const SlidingDivCol2 = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: Inter;
`;
const SlidingInnerDiv = styled.div`
  display: flex;
  gap: 5px;
  font-size: 11px;
  font-family: Inter;
  align-items: center;
`;
const SlidingDivCol3 = styled.div`
  display: flex;
  font-size: 12px;
  align-self: flex-start;
  align-items: center;
  font-family: Inter;
`;
const WalletIcons = styled.img`
  color: red;
`;
